import { calculateWindAnimationDuration } from '../../utils/wave-animation-calculations';
import windAnimationDirection from '../../utils/wind-animation';
import './wind.scss';

const Wind = props => {
  const css = 'wind';

  const setWindAnimation = {
    animationDuration:
      calculateWindAnimationDuration(props.windData.speed) /
        props.playbackSpeed +
      's',
  };

  const setWindRotation = {
    transformOrigin: 'center',
    transform: `rotate(${windAnimationDirection(
      props.windData.offshoreness.text
    )}deg)`,
  };

  return (
    <div style={setWindRotation} className={`${css}`}>
      <span style={setWindAnimation} className={`${css}__arrow`}>
        <svg viewBox="0 0 50 29.94" xmlns="http://www.w3.org/2000/svg">
          <path
            d="m25 9.24a5.06 5.06 0 0 1 -.4.54l-18.21 18.07a3.52 3.52 0 0 1 -3.73 1 3.44 3.44 0 0 1 -1.66-5.32 6.91 6.91 0 0 1 .5-.53l20.89-20.79a3.44 3.44 0 0 1 4.38-.72 4.12 4.12 0 0 1 .89.73q10.41 10.44 20.8 20.9a3.45 3.45 0 0 1 -4.34 5.37 8.8 8.8 0 0 1 -.72-.65l-17.93-18.04c-.14-.14-.26-.29-.47-.56z"
            fill={props.windData.offshoreness.color}
          />
        </svg>
      </span>
      <span
        style={setWindAnimation}
        className={`${css}__arrow ${css}__arrow--second`}
      >
        <svg viewBox="0 0 50 29.94" xmlns="http://www.w3.org/2000/svg">
          <path
            d="m25 9.24a5.06 5.06 0 0 1 -.4.54l-18.21 18.07a3.52 3.52 0 0 1 -3.73 1 3.44 3.44 0 0 1 -1.66-5.32 6.91 6.91 0 0 1 .5-.53l20.89-20.79a3.44 3.44 0 0 1 4.38-.72 4.12 4.12 0 0 1 .89.73q10.41 10.44 20.8 20.9a3.45 3.45 0 0 1 -4.34 5.37 8.8 8.8 0 0 1 -.72-.65l-17.93-18.04c-.14-.14-.26-.29-.47-.56z"
            fill={props.windData.offshoreness.color}
          />
        </svg>
      </span>
    </div>
  );
};

export default Wind;
